import { type ReactNode, useState, useEffect } from 'react';
import { AlertPopupContainer } from './alertPopup.styled';

import Heading from '../typography';
import Button from '../button';
import { Transition } from 'react-transition-group';
import { FormWrapper } from '../input-text/input.styled';
import { isEmpty } from 'lodash';
import FormSelect from '../dropdown/formSelect';
import clsx from 'clsx';
import { COLORS } from '../../constants/style/color';

interface AlertPopupType {
  isShow: boolean;
  closeModal?: () => void;
  handleSubmit?: any;
  title?: string;
  modalStatus?: string | ReactNode;
  setRemark?: any;
  remark?: any;
  loading?: boolean;
  customTitle?: string | ReactNode;
  ConfirmTitle?: string | ReactNode;
  chooseTenant?: boolean;
  optionData?: any;
  setSelectedTenant?: any;
  selectedTenant?: any;
  setSelectedParticipantId?: any;
  setSelectedEsppParticipantId?: any;
  centerHeading?: boolean;
  isPptView?: boolean;
  subTitle?: any;
  id?: string;
}

const AlertPopup = ({
  isShow,
  title,
  modalStatus,
  closeModal,
  handleSubmit,
  remark,
  setRemark,
  loading,
  customTitle,
  ConfirmTitle,
  chooseTenant = false,
  optionData,
  setSelectedTenant,
  selectedTenant,
  setSelectedParticipantId,
  setSelectedEsppParticipantId,
  centerHeading = false,
  isPptView = false,
  subTitle,
  id,
}: AlertPopupType): JSX.Element => {
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (isShow) {
      document.getElementsByTagName('html')[0].style.overflow = 'hidden';
    }
    return () => {
      document.getElementsByTagName('html')[0].style.overflow = 'unset';
    };
  }, [isShow]);
  const companyOption = optionData?.map((item: any) => {
    return {
      label:
        item.tenantName === 'Main' ? item.companyName : item.companyName + ' - ' + item.tenantName,
      value: item.tenantId ?? '',
      participantId: item.participantId ?? null,
      esppParticipantId: item.esppParticipantId ?? null,
    };
  });

  return (
    <Transition in={isShow} timeout={250}>
      {(state) => (
        <AlertPopupContainer id={id}>
          <div className={`modalBackdrop modalBackdrop-${state}`}>
            <div className={`sideBar sideBar-${state} `}>
              <div className='popupDialog'>
                <div className='popupContent'>
                  <Heading
                    id='alertPopupHeading'
                    variant='h5'
                    centerHeading={centerHeading}
                    className='mb-5'
                    title={
                      customTitle != null || customTitle !== undefined
                        ? customTitle
                        : modalStatus === 'View Remarks'
                          ? 'Rejection Reason'
                          : `Are you sure you want to ${
                              modalStatus === 'Approval'
                                ? 'approve'
                                : modalStatus === 'Reject'
                                  ? 'reject'
                                  : modalStatus === 'Delete'
                                    ? 'delete'
                                    : modalStatus === 'Deactivate'
                                      ? 'deactivate'
                                      : modalStatus === 'Cancel'
                                        ? 'cancel'
                                        : 'confirm'
                            } ${typeof title === 'string' ? title : ''}?`
                    }
                  />

                  {chooseTenant && (
                    <FormSelect
                      id='tenantSelect'
                      type='text'
                      name=''
                      placeholder='Select'
                      onChange={(value: string[]) => {
                        const participantId = companyOption.find(
                          (item: any) => item.value === value
                        ).participantId;
                        const esppParticipantId = companyOption.find(
                          (item: any) => item.value === value
                        ).esppParticipantId;
                        setSelectedTenant(value);
                        setSelectedParticipantId(participantId);
                        setSelectedEsppParticipantId(esppParticipantId);
                      }}
                      options={companyOption}
                      values={selectedTenant}
                      arrValue={selectedTenant}
                      isFormik={false}
                    />
                  )}
                  {subTitle && (
                    <div className='flex'>
                      <Heading
                        id='modalSubtitle'
                        variant='h6'
                        title={subTitle}
                        color={COLORS?.Gray}
                        className='scrollableContainer'
                      />
                    </div>
                  )}

                  {(modalStatus === 'Reject' || modalStatus === 'View Remarks') && (
                    <FormWrapper>
                      <textarea
                        id='remarksTextarea'
                        name='remarks'
                        placeholder='Enter Reason'
                        className={!isEmpty(errorMessage) ? 'border-red-600' : 'input-view'}
                        style={{ minHeight: '100px', minWidth: '430px', resize: 'none' }}
                        defaultValue={remark}
                        disabled={modalStatus === 'View Remarks'}
                        onChange={(e) => {
                          setRemark(e.target.value);
                          setErrorMessage('');
                        }}></textarea>
                      {errorMessage.length > 0 && (
                        <Heading
                          id='errorMessage'
                          variant='body-xs'
                          title={'Required Field'}
                          className={'mt-2'}
                        />
                      )}
                    </FormWrapper>
                  )}
                  <div className='popupButtons'>
                    {closeModal && !isPptView && (
                      <Button
                        id='cancelButton'
                        variant='primary-dark'
                        title={modalStatus === 'View Remarks' ? 'Close' : 'No'}
                        onClick={() => {
                          closeModal();
                        }}
                        showButtonInAdminView={true}
                      />
                    )}
                    {modalStatus !== 'View Remarks' && (
                      <Button
                        id='confirmButton'
                        variant='primary'
                        title={ConfirmTitle ?? 'Confirm'}
                        onClick={() => {
                          modalStatus === 'Reject'
                            ? !isEmpty(remark)
                              ? handleSubmit()
                              : setErrorMessage('Required Field')
                            : handleSubmit();
                        }}
                        icon={'check_circle'}
                        loading={loading}
                        showButtonInAdminView={true}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </AlertPopupContainer>
      )}
    </Transition>
  );
};

export default AlertPopup;
